export const SystemOwners = {
  en: {
    Email: 'Email',
    Phone: 'Phone',
    Status: 'Status',
    Blocked: 'Blocked',
    'Create System Owner': 'Create System Owner',
    'Edit System Owner': 'Edit System Owner',
    'First Name': 'First Name',
    'Last Name': 'Last Name',
    Password: 'Password',
    'Confirm Password': 'Confirm Password',
  },
  uk: {
    Email: 'Email',
    Phone: 'Телефон',
    Status: 'Статус',
    Blocked: 'Заблокований',
    'Create System Owner': 'Створити системного власника',
    'Edit System Owner': 'Редагувати системного власника',
    'First Name': "Ім'я",
    'Last Name': 'Прізвище',
    Password: 'Пароль',
    'Confirm Password': 'Підтвердити пароль',
  },
};
